import { CodePanelActions } from '../../constants';

// The content in code panel is updated
export const updateContent = (content, updateLocalContent) => ({
  type: CodePanelActions.UPDATE_CONTENT,
  content,
  updateLocalContent,
});
// Update selection code based on url
export const loadSelectionCode = (
  embeddingType = null,
  exampleName = null,
  exampleGroupName = null,
) => ({
  type: CodePanelActions.ON_SELECTION,
  embeddingType,
  exampleName,
  exampleGroupName,
});
export const loadSession = () => ({
  type: CodePanelActions.ON_LOAD,
});
export const saveContentToSession = (content) => ({
  type: CodePanelActions.SAVE_CODE,
  content,
});

// Insert the operation code to code editor either in "Property" or "Method" location
export const insertOperationCode = (insertedOperationCode, insertLocation) => ({
  type: CodePanelActions.INSERT_OPERATION_CODE,
  insertedOperationCode,
  insertLocation,
});
